
<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-confirm-and-add-other-action="createEntryAndAddOther"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :saveAndAddOtherButtonEnabled="saveAndAddOtherButtonEnabled"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from './form.vue';
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
      saveAndAddOtherButtonEnabled: true,
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_CUSTOMER_CULTURE_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.customerCulture;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },

    setObjectsFromIds: function(){
      this.entry.harvest = this.extraData.accountContext.allHarvests.filter( (item)=> item.id == this.entry.harvestId )[0];
      // console.log(this.entry.harvest);
      this.entry.culture = this.extraData.accountContext.allCultures.filter( (item)=> item.id == this.entry.cultureId )[0];
      this.entry.plantedUnit = this.extraData.globalContext.allCustomerUnits.filter( (item)=> item.id == this.entry.plantedUnitId )[0];
      // console.log(this.entry.harvest);
    },
    createEntry: function() {
      this.setObjectsFromIds();
      if (this.$refs.form.isFormValid()){
        this.$refs.baseNew.closeDialog();
        this.$emit("entry-created", this.entry);
        this.resetForm();
        return true;
      } else {
        return false;
      }
    },
    createEntryAndAddOther: function() {
      if (this.createEntry()){
        this.loadServerEntry();
        this.$refs.baseNew.newDialog = true;
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_CUSTOMER_CULTURE_QUERY = gql `
  {
    accountContext{
      customerCulture {
        harvestId
        cultureId
        plantedArea
        globalArea
        irrigatedArea
        produced
        isRented
        technicalLevel
        rentedQuantity
        validations
      }
      technicalLevels
      allHarvests{
        id
        name
      }
      allCultures{
        id
        name
      }
    } 
    globalContext{
      allCustomerUnits{
        id
        name
      }
    }
  }
`;

// const CREATE_CUSTOMER_CULTURE_MUTATION = gql `
//   mutation($input: CustomerCultureCreateInputObject!) {
//     createCustomerCulture(input: $input) {
//       customerCulture {  
//         id
//       }
//       errors
//     }
//   }
// `;

</script>

<style scoped></style>

